import { ACTIVE_MARKET_COUNTRIES } from "@workspace/countries";

type LocationDraft = {
  carId?: number | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country_code?: string | null;
};

const ACTIVE_COUNTRIES = new Set<string>(ACTIVE_MARKET_COUNTRIES);

function normalizeCountry(value: unknown): string {
  return typeof value === "string" ? value.trim().toUpperCase() : "";
}

export function safeProfileListingCountry(profileCountryCode?: string | null): string {
  const country = normalizeCountry(profileCountryCode);
  return country && country !== "US" && ACTIVE_COUNTRIES.has(country) ? country : "";
}

export function normalizeWizardLocationCountry<T extends LocationDraft>(
  draft: T,
  profileCountryCode?: string | null,
): T & { country_code: string } {
  const country = normalizeCountry(draft.country_code);
  const hasAddress = [draft.street, draft.city, draft.state, draft.zip]
    .some((value) => typeof value === "string" && value.trim().length > 0);

  // A saved listing's known country is authoritative, even before address entry.
  const staleUsPlaceholder = !draft.carId && country === "US" && !hasAddress;
  const resolvedCountry = !country || staleUsPlaceholder
    ? safeProfileListingCountry(profileCountryCode)
    : country;

  return { ...draft, country_code: resolvedCountry };
}